import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// Styles
import './Inquiry.css';
// Actions
import { addInquiryType } from '../../actions/actionCreators';
// Intl
import {
    FormattedMessage,
    injectIntl
} from "react-intl";

class Inquiry extends React.Component {

    addInquiry(inquiryType) {
        this.props.addInquiryType(inquiryType);
    }

    render() {
        return (
            <div>
                <div className="form">
                    <h2 className="form-text">
                        <FormattedMessage id='inquiryTypeRequest' defaultMessage="Request type" />
                    </h2>
                    <div className="boxes">
                        {this.renderInquiryTypes()}
                    </div>
                </div>
                <div className="info-text">
                    <p className="center"><FormattedMessage id='inquiryTypeInfoText' defaultMessage="Informational text here" />
                        <a rel="noopener noreferrer" target="_blank" href="https://www.datatilsynet.no/rettigheter-og-plikter/den-registrertes-rettigheter/"><FormattedMessage id='here' defaultMessage="here" /></a>
                        <span className=""><FormattedMessage id='inquiryTypeInfoText2' defaultMessage="Informational text here" /></span>
                    </p>
                </div>
            </div>
        )
    }

    renderInquiryTypes() {
        return this.props.inquiryTypes.map((inquiryType, index) => {
            return (
                <Link onClick={this.addInquiry.bind(this, inquiryType)} className="form-link" key={index} to={{
                    pathname: '/inquiry-form'
                }}>
                    <span className="link-text"><FormattedMessage id={inquiryType.name} defaultMessage='Inquiry type here' /></span>
                </Link>
            );
        });
    }
}

Inquiry.propTypes = {
    inquiryTypes: PropTypes.array.isRequired
};

let mapStateToProps = state => ({
    inquiryData: state.inquiryData
});

export default injectIntl(connect(mapStateToProps, {
    addInquiryType,
})(Inquiry));
